import { Panel } from "../../components/panels/Panel";
import { ConstructionDashboardVideosCount } from "./construction-components/ConstructionDashboardVideosCount";
import { ConstructionDashboardTotalDuration } from "./construction-components/ConstructionDashboardTotalDuration";


export const ConstructionDashboard = () => {
  return (
    <Panel title="TABLEAU DE BORD">

      <div className="h-full flex gap-4">
        <ConstructionDashboardVideosCount/>

        <div className="flex items-center w-1/4">
          <ConstructionDashboardTotalDuration/>
        </div>
      </div>

    </Panel>
  )
};